import React, { useEffect } from "react";
import { Alert } from "reactstrap";

import {
  HIDE_TOAST_DEFAULT_TIME_IN_SECONDS,
  ICON_NAME_COLOR_MAP,
} from "@/constants/UtilConstants";
import Icon from "../Icon/Icon";
import styles from "./AlertToast.module.css";
import { IAlertToastProps } from "./AlertToast.types";

function AlertToast({
  message,
  type,
  autoHide,
  onDismissCallBack,
}: IAlertToastProps) {
  const { color, name } = ICON_NAME_COLOR_MAP[type];

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (autoHide?.enabled) {
      const hideTimeout = setTimeout(
        () => {
          onDismissCallBack();
          clearTimeout(hideTimeout);
        },
        (autoHide?.hideTimeInSeconds ?? HIDE_TOAST_DEFAULT_TIME_IN_SECONDS) *
          1000,
      );
      return () => {
        clearTimeout(hideTimeout);
      };
    }
  }, [type, autoHide]);

  if (message) {
    return (
      <Alert
        visible
        className={`d-flex align-items-center ${styles.alert}`}
        color={type}
      >
        <Icon
          className={styles.icon}
          name={name}
          fill={color}
          width={22}
          height={22}
        />
        <p className={styles.alertMessage}>{message}</p>
        {!autoHide?.enabled && (
          <Icon
            className="ms-auto"
            name="close"
            fill="#E5163580"
            width={20}
            height={20}
            onClick={onDismissCallBack}
            role="button"
          />
        )}
      </Alert>
    );
  }
  return null;
}

export default AlertToast;
